/*
 * Duplicates contact / partnership form submissions into a Google Sheet
 * via an Apps Script Web App. The standard Shopify form POST proceeds
 * untouched; we fire a keepalive request right before navigation.
 *
 * A form opts in via data attributes:
 *   data-sheets-form     - logical form id ("contact" | "partnership")
 *   data-sheets-endpoint - Apps Script Web App URL
 *   data-sheets-token    - shared secret matching SECRET_TOKEN in the script
 */
(function () {
  'use strict';

  function bindForm(form) {
    if (form.dataset.sheetsBound === 'true') return;
    form.dataset.sheetsBound = 'true';

    form.addEventListener('submit', function () {
      var endpoint = form.dataset.sheetsEndpoint;
      var token = form.dataset.sheetsToken;
      if (!endpoint || !token) return;

      var emailField = form.querySelector('input[name="contact[email]"]');
      var nameField = form.querySelector(
        'input.contact-field__input:not([name="contact[email]"])'
      );
      var messageField = form.querySelector('textarea.contact-field__input--textarea');

      var payload = {
        token: token,
        form: form.dataset.sheetsForm,
        name: nameField ? nameField.value.trim() : '',
        email: emailField ? emailField.value.trim() : '',
        message: messageField ? messageField.value.trim() : '',
        page: window.location.href,
      };

      try {
        // text/plain keeps the request "simple" (no CORS preflight);
        // keepalive lets it complete while the page navigates away.
        fetch(endpoint, {
          method: 'POST',
          mode: 'no-cors',
          keepalive: true,
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify(payload),
        });
      } catch (error) {
        // Never block the native Shopify submission.
      }
    });
  }

  function init() {
    document.querySelectorAll('form[data-sheets-form]').forEach(bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
